
import { useState } from 'react';
import { isValidSpotifyUrl } from '@/lib/spotify';

export function useSpotifyUrlValidation() {
  const [spotifyUrl, setSpotifyUrl] = useState('');
  const [isUrlValid, setIsUrlValid] = useState(true);

  const validateSpotifyUrl = (url: string) => {
    const valid = isValidSpotifyUrl(url);
    setIsUrlValid(valid);
    return valid;
  };

  const handleSpotifyUrlChange = (url: string) => {
    setSpotifyUrl(url);
    if (url === '') {
      setIsUrlValid(true);
      return true;
    }
    return validateSpotifyUrl(url);
  };

  return {
    spotifyUrl,
    isUrlValid,
    validateSpotifyUrl,
    handleSpotifyUrlChange
  };
}
